import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import { validatePresence } from 'ember-changeset-validations/validators';
import lookupValidator from 'ember-changeset-validations';
import JournalContactInfo from 'donor-elf-web/lib/models/journal-contact-info';
import Store from '@ember-data/store';
import RecommendationModel from 'donor-elf-web/models/recommendation';

let validation = {
  recommendedByContactId: validatePresence({
    presence: true,
    message: "Can't be blank",
  }),
};

interface ComponentArgs {
  journalContactInfo: JournalContactInfo;
  onSaved: (recommendation: RecommendationModel) => void;
  onCancel: () => void;
}

export default class JournalCellContactRecommendedByComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    let record = this.store.createRecord('recommendation', {
      recommendedContactId: args.journalContactInfo.contactId,
    });
    this.changeset = new Changeset(
      record,
      lookupValidator(validation),
      validation,
    );
  }

  @service declare store: Store;

  @tracked saving = false;
  @tracked showValidationErrors = false;
  @tracked saveError = null;

  changeset: any;

  @action
  async save() {
    if (this.saving) {
      return;
    }
    this.saving = true;
    this.showValidationErrors = false;
    await this.changeset.validate();
    if (this.changeset.get('isValid')) {
      try {
        await this.changeset.save();
        this.saving = false;
        this.args.onSaved(this.changeset.get('data'));
      } catch (error) {
        this.saveError = error;
        this.saving = false;
      }
    } else {
      this.saving = false;
      this.showValidationErrors = true;
    }
  }
}
